export default __webpack_public_path__ + "static/media/lining14.065526ca.jpg";